import { CoreUtils, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { RouteNavMatch } from '~/core/enums';

export const getGameStateDescriptionForAnalytics = (gameState: ShortCodeEnums.GameState): string => {
    if (CoreUtils.isPregame(gameState)) {
        return 'pregame';
    } else if (CoreUtils.isGameLive(gameState)) {
        return 'ingame';
    } else {
        return 'postgame';
    }
};

export const getDataLayer = () => {
    window.dataLayer = window.dataLayer || [];

    return window.dataLayer;
};

export const sendGoalDetailVideoStartEvent = (
    highlightClipId: number,
    gameState: ShortCodeEnums.GameState | null,
    pageName: RouteNavMatch.SCORES | RouteNavMatch.GAMECENTER,
    goalScorer: string,
    homeTeamAbbrev: string,
    awayTeamAbbrev: string
) => {
    getDataLayer().push({
        event: 'goal_detail_video_start',
        goal_scorer: goalScorer,
        content_id: highlightClipId,
        teams_playing: `${homeTeamAbbrev},${awayTeamAbbrev}`,
        tri_code: window.__SITE_SETTINGS__.franchise.triCode,
        page_name: pageName,
        game_status: gameState && getGameStateDescriptionForAnalytics(gameState),
    });
};
